import React from 'react'
import { IQuestion } from '../../classes/Question'
import Grid from '@mui/material/Unstable_Grid2';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

interface Props {
  index: number,
  question: IQuestion,
}

const OuterCard = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#ffff',
  padding: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
  },
  marginBottom: theme.spacing(3),
  boxShadow: 'none',
  border: 'none',
  borderRadius: '0',
}));

const SurveyChart = (props: Props) => {
  return (
    <>
    <Grid xs={12} md={6} >
      <OuterCard>
        {props.question.render(props.index, props.question)}
      </OuterCard>
    </Grid>
    </>
  );
}

export default SurveyChart;